import request from "@/utils/request";
import { SERVERPATH } from "@/config";

// 品牌列表
export function MarketBrandList(data) {
  return request({
    url: `${SERVERPATH}/Market/brandList`,
    method: "post",
    data
  });
}

// 品牌详情
export function MarketBrandInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/brandInfo`,
    method: "post",
    data
  });
}

// 品牌新增
export function MarketBrandAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/brandAdd`,
    method: "post",
    data
  });
}

// 品牌编辑
export function MarketBrandEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/brandEdit`,
    method: "post",
    data
  });
}

// 品牌删除
export function MarketBrandDel(data) {
  return request({
    url: `${SERVERPATH}/Market/brandDel`,
    method: "post",
    data
  });
}

// 大类列表
export function MarketLargeCatList(data) {
  return request({
    url: `${SERVERPATH}/Market/largeCatList`,
    method: "post",
    data
  });
}

// 大类详情
export function MarketLargeCatInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/largeCatInfo`,
    method: "post",
    data
  });
}

// 大类新增
export function MarketLargeCatAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/largeCatAdd`,
    method: "post",
    data
  });
}

// 大类编辑
export function MarketLargeCatEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/largeCatEdit`,
    method: "post",
    data
  });
}

// 大类删除
export function MarketLargeCatDel(data) {
  return request({
    url: `${SERVERPATH}/Market/largeCatDel`,
    method: "post",
    data
  });
}

// 小类列表
export function MarketSmallCatList(data) {
  return request({
    url: `${SERVERPATH}/Market/smallCatList`,
    method: "post",
    data
  });
}

// 小类详情
export function MarketSmallCatInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/smallCatInfo`,
    method: "post",
    data
  });
}

// 小类新增
export function MarketSmallCatAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/smallCatAdd`,
    method: "post",
    data
  });
}

// 小类编辑
export function MarketSmallCatEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/smallCatEdit`,
    method: "post",
    data
  });
}

// 小类删除
export function MarketSmallCatDel(data) {
  return request({
    url: `${SERVERPATH}/Market/smallCatDel`,
    method: "post",
    data
  });
}

// 基础商品列表
export function MarketGoodsList(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsList`,
    method: "post",
    data
  });
}
// 库存待上架列表
export function MarketIsXiaJiaProduct(data) {
  return request({
    url: `${SERVERPATH}/Market/isXiaJiaProduct`,
    method: "post",
    data
  });
}

// 基础商品详情
export function MarketGoodsInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsInfo`,
    method: "post",
    data
  });
}

// 基础商品新增
export function MarketGoodsAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsAdd`,
    method: "post",
    data
  });
}

// 基础商品编辑
export function MarketGoodsEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsEdit`,
    method: "post",
    data
  });
}

// 基础商品删除
export function MarketGoodsDel(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsDel`,
    method: "post",
    data
  });
}

// 批量导入盘库
export function MarketGoodsPanKuExcel(data) {
  return request({
    url: `${SERVERPATH}/Market/importPanKuExcel`,
    method: "post",
    data
  });
}

// 库存
export function MarketGoodsInventory(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsInventory`,
    method: "post",
    data
  });
}

// 库存预警列表
export function MarketGoodsInventoryWarningList(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsInventoryWarningList`,
    method: "post",
    data
  });
}

// 盘库
export function MarketGoodsInventoryPan(data) {
  return request({
    url: `${SERVERPATH}/Market/goodsInventoryPan`,
    method: "post",
    data
  });
}

// 库存明细列表
export function MarketInventoryRecordList(data) {
  return request({
    url: `${SERVERPATH}/Market/inventoryRecordList`,
    method: "post",
    data
  });
}

// 产品列表
export function MarketProductList(data) {
  return request({
    url: `${SERVERPATH}/Market/productList`,
    method: "post",
    data
  });
}

// 产品详情
export function MarketProductInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/productInfo`,
    method: "post",
    data
  });
}

// 产品新增
export function MarketProductGoodsAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/productGoodsAdd`,
    method: "post",
    data
  });
}

// 产品编辑
export function MarketProductGoodsEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/productGoodsEdit`,
    method: "post",
    data
  });
}

// 产品删除
export function MarketProductDel(data) {
  return request({
    url: `${SERVERPATH}/Market/productDel`,
    method: "post",
    data
  });
}

// 产品库存
export function MarketProductInventory(data) {
  return request({
    url: `${SERVERPATH}/Market/productInventory`,
    method: "post",
    data
  });
}

// 产品盘库
export function MarketProductInventoryPan(data) {
  return request({
    url: `${SERVERPATH}/Market/productInventoryPan`,
    method: "post",
    data
  });
}

// 产品上下架
export function MarketProductSale(data) {
  return request({
    url: `${SERVERPATH}/Market/productSale`,
    method: "post",
    data
  });
}

// 批量设置产品销量
export function MarketProductEditSaleNum(data) {
  return request({
    url: `${SERVERPATH}/Market/editProductSaleNum`,
    method: "post",
    data
  });
}

// 集市订单列表
export function MarketProductOrderList(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderList`,
    method: "post",
    data
  });
}

// 集市订单详情
export function MarketProductOrderInfo(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderInfo`,
    method: "post",
    data
  });
}

// 订单发货
export function MarketProductOrderFaHuo(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderFaHuo`,
    method: "post",
    data
  });
}

// 订单取消
export function MarketProductOrderCancel(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderCancel`,
    method: "post",
    data
  });
}

// 订单完成
export function MarketProductOrderFinish(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderFinish`,
    method: "post",
    data
  });
}

// 删除订单
export function MarketProductOrderDel(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderDel`,
    method: "post",
    data
  });
}

// 订单退款
export function MarketProductOrderRefund(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderRefund`,
    method: "post",
    data
  });
}

// 产品服务类型列表
export function MarketProductServiceTypeList(data) {
  return request({
    url: `${SERVERPATH}/Market/productServiceTypeList`,
    method: "post",
    data
  });
}

// 产品服务类型详情
export function MarketProductServiceTypeInfo(data) {
  return request({
    url: `${SERVERPATH}/Market/productServiceTypeInfo`,
    method: "post",
    data
  });
}

// 产品服务类型新增
export function MarketProductServiceTypeAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/productServiceTypeAdd`,
    method: "post",
    data
  });
}

// 产品服务类型编辑
export function MarketProductServiceTypeEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/productServiceTypeEdit`,
    method: "post",
    data
  });
}

// 产品服务类型删除
export function MarketProductServiceTypeDel(data) {
  return request({
    url: `${SERVERPATH}/Market/productServiceTypeDel`,
    method: "post",
    data
  });
}

// 商品库存调整（按 SN 码增减库存）
export function MarketGoodsAdjustInventory(data) {
  return request({
    url: `/admin/Market/adjustInventory`,
    method: "post",
    data
  });
}

// 商品 SN 列表
export function MarketGoodsInventorySnList(data) {
  return request({
    url: `/admin/Market/inventorySnList`,
    method: "post",
    data
  });
}

// 删除单件库存
export function MarketProductItemDel(data) {
  return request({
    url: `/admin/Market/productItemDel`,
    method: "post",
    data
  });
}
// 集市售后查看物流
export function MarketProductLogistic(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/logistic`,
    method: "post",
    data
  });
}
// 集市售后查看物流-多包裹-副物流
export function MarketProductSonLogistic(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/allLogistic`,
    method: "post",
    data
  });
}

export function AdminKuaidi100(data) {
  return request({
    url: `/admin/kuaidi100`,
    method: "post",
    data
  });
}

// 多包裹导入
export function MarketImportSonLogistic(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/importLogisticExcel`,
    method: "post",
    data
  });
}

// 订单备注
export function MarketProductOrderNote(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/productOrderNote`,
    method: "post",
    data
  });
}

// 订单改价
export function MarketProductOrderAdjustPrice(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/adjustOrderPrice`,
    method: "post",
    data
  });
}

// 导出订单
export function MarketExportOrder(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/exportOrder`,
    method: "post",
    data
  });
}

// 导入订单
export function MarketImportOrder(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/importOrder`,
    method: "post",
    data
  });
}

// 随手购详情 productId
export function MarketRandomShopInfo(productId) {
  return request({
    url: `${SERVERPATH}/Market/getSuiShouGou`,
    method: "post",
    data: { productId }
  });
}

/**
 * 批量编辑随手购
 * @param array productIds
 * @param array suishougou_productIds
 * @returns
 */
export function MarketRandomShopEdit(productIds, suishougou_productIds) {
  return request({
    url: `${SERVERPATH}/Market/productSuiShouGouAdd`,
    method: "post",
    data: {
      productId: productIds,
      suishougou_productId: suishougou_productIds
    }
  });
}

/**
 * 推送订单到聚水潭
 * @param string order_no
 * @returns
 */
export function MarketPushOrder(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/tuisongdingdan`,
    method: "post",
    data: data
  });
}

/**
 * 推送订单到聚水潭
 * @param string order_no
 * @returns
 */
export function MarketClearFengxianOrder(data) {
  return request({
    url: `${SERVERPATH}/MarketOrder/qingkonggfengxian`,
    method: "post",
    data: data
  });
}

/**
 * 产品SKU排序
 * @returns
 */
export function MarketProductSkuSort(data) {
  return request({
    url: `${SERVERPATH}/Market/productGoodsSkuEdit`,
    method: "post",
    data: data
  });
}

export function MarketProductTagAdd(data) {
  return request({
    url: `${SERVERPATH}/Market/productTagAdd`,
    method: "post",
    data
  });
}

export function MarketProductTagEdit(data) {
  return request({
    url: `${SERVERPATH}/Market/productTagEdit`,
    method: "post",
    data
  });
}

export function MarketProductTagDel(data) {
  return request({
    url: `${SERVERPATH}/Market/productTagDel`,
    method: "post",
    data
  });
}

export function MarketProductTagList(params) {
  return request({
    url: `${SERVERPATH}/Market/productTagList`,
    method: "get",
    params
  });
}

// 库存单件列表
export function MarketInventoryList(data) {
  return request({
    url: `${SERVERPATH}/Market/inventoryList`,
    method: "post",
    data
  });
}
